import { Scene, WebXRDefaultExperience, WebXRSessionManager, WebXRState, Mesh } from '@babylonjs/core';

export interface XRSetupResult {
  xrExperience: WebXRDefaultExperience | null;
  isSupported: boolean;
}

export async function setupWebXR(scene: Scene, floorMeshes: Mesh[]): Promise<XRSetupResult> {
  const isSupported = await WebXRSessionManager.IsSessionSupportedAsync('immersive-ar');

  if (!isSupported) {
    console.warn('WebXR AR is not supported on this device/browser');
    return { xrExperience: null, isSupported: false };
  }

  const xrExperience = await scene.createDefaultXRExperienceAsync({
    uiOptions: {
      sessionMode: 'immersive-ar',
      referenceSpaceType: 'local-floor'
    },
    floorMeshes,
    optionalFeatures: true
  });

  // Listen for XR state changes
  xrExperience.baseExperience.onStateChangedObservable.add((state: WebXRState) => {
    switch (state) {
      case WebXRState.ENTERING_XR:
        updateStatus('Entering AR...');
        break;
      case WebXRState.IN_XR:
        updateStatus('AR Active');
        break;
      case WebXRState.EXITING_XR:
        updateStatus('Exiting AR...');
        break;
      case WebXRState.NOT_IN_XR:
        updateStatus('Ready - Tap Enter AR');
        break;
    }
  });

  // Log session initialization
  xrExperience.baseExperience.sessionManager.onXRSessionInit.add(() => {
    console.log('[WebXR] AR session initialized');
  });

  xrExperience.baseExperience.sessionManager.onXRSessionEnded.add(() => {
    console.log('[WebXR] AR session ended');
  });

  return { xrExperience, isSupported: true };
}

function updateStatus(message: string): void {
  const statusEl = document.getElementById('status');
  if (statusEl) statusEl.textContent = message;
}
